__turbopack_context__.v({
  "summary": "CollectionSummary-module-scss-module__FDHEvW__summary",
  "summaryClamp": "CollectionSummary-module-scss-module__FDHEvW__summaryClamp",
  "upcomingEvents": "CollectionSummary-module-scss-module__FDHEvW__upcomingEvents",
});
